import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import MasteringAiMain from "../../images/services-usa/ai/mastering_ai_main.svg";

function Mastringai() {
  return (
    <section className="mastring_ai p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              How TekRevol’s Clients and Their Stakeholders Are{" "}
              <span>Mastering AI for Business</span>
            </h2>
            <p>
              We build AI solutions that firstly, deliver business value, and
              secondly, are secure and trustworthy to handle the most generic to
              specific tasks of your business cycle. Speaking boldly, 100% of
              our clients achieve at least 7.58X ROI on their AI investments
              because we combine talent ingenuity, right technology stack and
              strong datasets. We start with the objective of automating and
              accelerating the second-degree tasks to help businesses humanize
              KPIs and processes that need more time, effort and immense human
              concentration.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mt-4 mt-md-0"
          >
            {/* <StaticImage
              src="../../images/services-usa/ai/mastering_ai_main.svg"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={548}
              height={560}
            /> */}
            <img
              src={MasteringAiMain}
              alt="tekrevol"
              width="548"
              height="560"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Mastringai;
